
import { onMounted, ref } from "vue";
import axios from "axios";
import { Rider } from "@/models/rider";
import { Raterange } from "@/models/raterange";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
export default {
  name: "AdminPaymentmethodList",
  components: { VPagination },
  setup() {
    const paymentmethods = ref([]);
    const lastPage = ref(0);
    const selected = ref(0);

    const load = async (page = 1) => {
      const { data } = await axios.get(`paymentmethods?page=${page}`);
      paymentmethods.value = data.data;
      lastPage.value = data.meta.last_page;
    };

    onMounted(load);
    const select = (id: number) => {
      selected.value = selected.value !== id ? id : 0;
    };

    const del = async (id: number) => {
      if (confirm("Are You Sure?")) {
        //  await axios.delete(`paymentmethods/${id}`);

        paymentmethods.value = paymentmethods.value.filter(
          (u: Rider) => u.id !== id
        );
      }
    };

    return {
      paymentmethods,
      lastPage,
      del,
      load,
      selected,
      select,
    };
  },
};
